import { Text } from '../../../common/text.constants';

export const NavigationText = {
	leave: Text.leaveThePage,
	leaveWithoutSaving: Text.leaveWithoutSaving,
	stay: Text.stayOnThisPage,
	saveAndLeave: Text.saveAndLeave,
};
